export default "__VITE_ASSET__DcETi$AD__"